import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Capacitor } from "@capacitor/core";
import { Home, FileText, Briefcase, MessageSquare, User, Sparkles, LogIn, Plus } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import NotificationBell from "@/components/NotificationBell";

// Uygulama hissi veren alt navigasyon çubuğu. Sadece müşteri veya oturumsuz
// kullanıcıya, native uygulamada görünür (CSS ile). Admin ve sağlayıcı kendi
// panel düzenlerini kullandığı için onlarda gizli.
export default function MobileTabBar() {
  const { user } = useAuth();
  const location = useLocation();
  const path = location.pathname;

  const role = user?.role;
  const isPanelUser = role === "admin" || role === "saglayici";
  // Tam ekran akışlarda çubuğu gizle (kendi alt butonları/akışı var).
  // Dikkat: talep sihirbazı TAM "/rezervasyon" — startsWith kullanma, yoksa
  // "/rezervasyonlarim" (İşlerim) sayfasında da bar yanlışlıkla gizlenir.
  const hiddenOn =
    path === "/giris" ||
    path === "/kayit" ||
    path === "/rezervasyon" ||
    path.startsWith("/panel") ||
    path.startsWith("/admin");

  const visible = !isPanelUser && !hiddenOn;

  // Görünürken içerik altına boşluk bırakmak için <body>'ye sınıf ekle.
  useEffect(() => {
    if (visible) document.body.classList.add("has-tabbar");
    else document.body.classList.remove("has-tabbar");
    return () => document.body.classList.remove("has-tabbar");
  }, [visible]);

  if (!visible) return null;

  // Giriş yapmış müşteri: ortada vurgulu "Talep Oluştur" aksiyonu (uygulama kalıbı).
  const tabs = user
    ? [
        { to: "/taleplerim", label: "Taleplerim", icon: FileText, match: (p) => p.startsWith("/taleplerim") },
        { to: "/rezervasyonlarim", label: "İşlerim", icon: Briefcase, match: (p) => p.startsWith("/rezervasyonlarim") },
        { to: "/rezervasyon", label: "Talep Oluştur", icon: Plus, cta: true, match: () => false },
        { to: "/mesajlarim", label: "Mesajlar", icon: MessageSquare, match: (p) => p.startsWith("/mesajlarim") },
        { to: "/hesabim", label: "Hesabım", icon: User, match: (p) => p.startsWith("/hesabim") || p.startsWith("/adreslerim") },
      ]
    : [
        { to: "/", label: "Ana Sayfa", icon: Home, match: (p) => p === "/" },
        { to: "/rezervasyon", label: "Talep Oluştur", icon: Sparkles, match: (p) => p.startsWith("/rezervasyon") },
        { to: "/giris", label: "Giriş", icon: LogIn, match: (p) => p === "/giris" },
      ];

  const isNative = Capacitor.isNativePlatform();

  return (
    <>
      {/* Native uygulama: sayfa header'ları gizli — zil sağ üstte yüzer
          (profil menüsü yok; Hesabım zaten alt barda) */}
      {isNative && user && (
        <div
          className="native-float-top fixed top-2.5 right-3 z-40 rounded-full bg-white border border-slate-100 pak-shadow"
          data-testid="native-customer-chrome"
        >
          <NotificationBell />
        </div>
      )}
      <nav className="mobile-tabbar" data-testid="mobile-tabbar">
      <div className="mobile-tabbar-inner">
        {tabs.map((t) => {
          const Icon = t.icon;
          const active = t.match(path);
          if (t.cta) {
            return (
              <Link key={t.to} to={t.to} className="tab-cta" data-testid={`tab-${t.to}`}>
                <span className="tab-cta-circle">
                  <Icon className="h-6 w-6" strokeWidth={2.4} />
                </span>
                <span>{t.label}</span>
              </Link>
            );
          }
          return (
            <Link key={t.to} to={t.to} className={active ? "active" : ""} data-testid={`tab-${t.to}`}>
              <Icon className="h-5 w-5" strokeWidth={active ? 2.4 : 2} />
              <span>{t.label}</span>
            </Link>
          );
        })}
      </div>
      </nav>
    </>
  );
}
